import { render, staticRenderFns } from "./dart-dialog.vue?vue&type=template&id=88c7d00e&scoped=true"
import script from "./dart-dialog.vue?vue&type=script&lang=js"
export * from "./dart-dialog.vue?vue&type=script&lang=js"
import style0 from "./dart-dialog.vue?vue&type=style&index=0&id=88c7d00e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7d00e",
  null
  
)

export default component.exports